import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/icontfont/iconfont.css";

import "@/assets/css/reset.css";
import "@/assets/css/index.css";
import "@/assets/css/swiper.min.css";
import "nprogress/nprogress.css";
// 引入element-ui的样式
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$baseURL = process.env.VUE_APP_BASE_URL;
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
